import React, { useEffect } from "react";
import "react-dropdown/style.css";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import appStore from '../assets/download_on_app_store.svg';
import googlePlay from '../assets/google-play-badge.png';
import ur1 from "../assets/logo-large.jpg";
import { fetchUser as fetchAuthUser, login } from "../common/slices/auth";
import { fetchUser } from "../common/slices/user";
import { androidFilepath, pathNames } from "../constants";
import { BlackButton } from "./Buttons";
import FormPasswordInput from "./FormPasswordInput";
import FormTextInput from "./FormTextInput";
import Row from "./Row";

const Form = styled.div`
    display: flex;
    gap: 1rem;
    background: white;
    padding: 0 5rem;
    flex-direction: column;
    min-width: 300px;
    max-width: 500px;
    border-left: 1px solid #b9b9b9;

    @media(max-width: 920px) {
        border-left: none;
        flex: 1;
    }
`;

const Container = styled(Row)`
    flex: 1;
    background: white;
    align-items: center;
    justify-content: center;
    display: flex;
    gap: 5rem;

    @media(max-width: 920px) {
        flex-wrap: wrap;
        align-content: center;
    }
`;

const Logo = styled.img`
    display: flex;
    flex-shrink: 0;
    align-self: center;
`;

const DLIcon = styled.img`
    cursor: pointer;
`;

const Login = () => {
    const dispatch = useDispatch();
    const nav = useNavigate();
    const {
        control,
        handleSubmit,
        setError,
        formState: { errors, isValid, isSubmitting },
    } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
    });

    useEffect(() => {
        (async () => {
            try {
                await dispatch(fetchAuthUser());
                const profile = await dispatch(fetchUser());
                if (profile) {
                    profile?.role === "ADMIN" ?
                        nav(pathNames.SAFETYFORMS) :
                        nav(pathNames.ACCESSDENIED)
                }
            } catch (ex) {

            }
        })()
    }, [dispatch, nav])


    const formFields = { control, errors };

    const onSubmit = async ({ email, password }) => {
        try {
            const user = await dispatch(login(email, password));
            const { isSignedIn, nextStep } = user;
            if (!isSignedIn) {
                switch (nextStep.signInStep) {
                    case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
                        nav(pathNames.NEWPASSWORD);
                        break;
                    default:
                        break;
                }
            } else {
                await dispatch(fetchAuthUser());
                const profile = await dispatch(fetchUser());
                profile?.role === "ADMIN" ?
                    nav(pathNames.SAFETYFORMS) :
                    nav(pathNames.ACCESSDENIED)
            }
        } catch (ex) {
            setError("email", { message: ex.message });
            setError("password", { message: ex.message });
        }
    };

    return (
        <Container>
            <Logo src={ur1} style={{ height: '200px' }} />
            <Form>
                <FormTextInput {...formFields} name="email" label="Email" placeholder="Enter email" rules={{ required: true }} />
                <FormPasswordInput {...formFields} name="password" label="Password" placeholder="Enter password" rules={{ required: true }} />
                <BlackButton onClick={handleSubmit(onSubmit)} disabled={!isValid || isSubmitting}>
                    Login
                </BlackButton>
                {/* <Divider.Horizontal /> */}
                <Row style={{ justifyContent: 'space-between' }}>
                    <DLIcon src={appStore} onClick={() => window.open('https://apps.apple.com/us/app/united-roofing/id6478508212', '_blank')} />
                    <DLIcon src={googlePlay} style={{ height: '40px' }} onClick={() => window.open(androidFilepath, '_blank')} />
                </Row>
            </Form>
        </Container>
    );
};

export default Login;
